export default {
  title: 'Accesso con SSO',
  subtitle:
    'Inserisci la tua email aziendale per continuare con Single Sign-On',
  continueButton: 'Continua con SSO',
  errors: {
    noSsoConfiguration:
      'Nessuna configurazione SSO trovata per questo dominio email. Contatta il tuo amministratore.'
  }
};
